import React,  { Component } from 'react';
import { Modal, Radio, Spin, message } from 'antd';
import API_URL from '../../../../common/url';
import $ from '../../../../common/AjaxRequest';
import SearchRetrieve from '../../../common/SearchRetrieve.new';
import format from '../../../shared/format';
import genConfig from '../../../shared/genConfig';
import { generateOptions } from '../../../shared/selectFn';
import { Gender, PiIdentity } from '../constants';

const RadioGroup = Radio.Group;
const typeInConfig = {
    add: {
        title: '添加参与临床试验人员',
        message: '添加成功',
        url: API_URL.user.addPI,
    },
    edit: {
        title: '修改参与临床试验人员',
        message: '修改成功',
        url: API_URL.hospital.editDoctor,
    }
};
const PiIdentityRadio = generateOptions(PiIdentity, 'radio');

class Update extends Component {
    state = {
        visible: false,
        loading: false,
        data: {},
    }

    user = {}

    config = {}

    isConcrete = false

    reference = true

    querySite = () => {
        const { data } = this.state;
        const { invSiteId } = data;
        this.setState({ loading: true });
        $.sendRequest({
            url: API_URL.site.list,
            data: { siteId: invSiteId },
            dataType: 'json',
            doneResult: res => {
                const [item] = res.data.siteList.datas || [];
                const { reference, hospitalId, hospitalName, departmentName } = item || {};
                this.reference = reference;
                data.hospitalId = hospitalId;
                data.hospitalName = hospitalName;
                data.departmentName = departmentName;
                this.setState({
                    data,
                    loading: false
                }, () => {
                    item && this.queryPi();
                });
            },
        });
    }

    queryPi = () => {
        const { data: { userName, doctorPostId, hospitalId } } = this.state;
        this.setState({ loading: true });
        $.sendRequest({
            url: API_URL.hospital.queryDoctorListByDepId,
            data: {
                keywords: userName,
                hospitalId,
                doctorPostId,
            },
            dataType: 'json',
            doneResult: res => {
                const [data = {}] = res.datas || [];
                data.value = data.userId;
                data.text = data.userCompellation;
                this.handleChange(data, 'user');
                this.setState({ loading: false });
            },
        });
    }

    show = (record, type) => {
        const { siteId, invState, investigationSiteName, investigationSiteCode } = sessionStorage;
        this.config = genConfig(typeInConfig, type);
        this.isConcrete = invState == 2;
        this.reference = true;
        const data = { ...record };
        if (this.isConcrete && this.config.add) {
            data.invSiteId = siteId;
            data.invSiteName = `${investigationSiteName}-(${investigationSiteCode})`;
        } else if (this.config.edit) {
            data.invSiteName = `${data.investigationSiteName}-(${data.investigationSiteCode})`;
        }
        this.setState({
            data,
            visible: true,
        }, () => {
            if (
                this.config.edit ||
                (this.isConcrete && this.config.add)
            ) {
                this.querySite();
            }
        });
    }

    hide = () => {
        this.user = {};
        this.setState({
            params: {},
            visible: false,
        });
    }

    handleChange = (value, key) => {
        const { data } = this.state;
        switch (key) {
            case 'invSite': {
                const { value: id, text: name, hospitalId, hospitalName, reference, departmentName } = value;
                data.invSiteId = id;
                data.invSiteName = name;
                this.reference = id ? reference : true;
                data.hospitalId = hospitalId;
                data.hospitalName = hospitalName;
                data.departmentName = departmentName;
                data.piIdentity = undefined;
                this.handleChange({}, 'user');
                break;
            }
            case 'user': {
                const { value: id, text: name } = value;
                data.userId = id;
                data.userName = name;
                this.user = value;
                break;
            }
            default: {
                data[key] = value;
                break;
            }
        }
        this.setState({ data });
    }

    handleSubmit = () => {
        const { data } = this.state;
        const { userId, invSiteId, piIdentity, memberId } = data;
        if (!invSiteId) {
            return message.warning('请选择中心');
        }
        if (!userId) {
            return message.warning('请选择参与临床试验人员');
        }
        if (!piIdentity) {
            return message.warning('临床项目身份不能为空');
        }
        this.setState({ loading: true });
        const options = {
            url: this.config.url,
            data: {
                ...this.user,
                userId,
                invSiteId,
                piIdentity,
                siteId: invSiteId,
                memberId
            },
            dataType: 'json',
            doneResult: () => {
                message.success(this.config.message);
                this.hide();
                this.setState({ loading: false }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    render() {
        const { loading, visible, data } = this.state;
        const asterisk = <span style={{color: 'red'}}>*</span>;
        // 关联中心，不能选择PI
        const NewPiIdentityRadio = React.Children.map(PiIdentityRadio, (element) => {
            if (this.reference && element.key === 'PI') {
                return React.cloneElement(element, { disabled: true });
            }
            return element;
        });
        return (
            <Modal
                title={this.config.title}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                confirmLoading={loading}
                maskClosable={false}
                width="600px"
            >
                <Spin spinning={loading}>
                    <div className="modal-content">
                        <ul className="modal-list">
                            <li className="modal-item" style={{ lineHeight: '28px' }}>
                                <div className="item-left">{(!this.isConcrete && this.config.add) && asterisk}中心名称(中心编号):</div>
                                <div className="item-right">
                                    <SearchRetrieve
                                        keyword='searchKey'
                                        style={{ width: 200 }}
                                        placeholder="输入中心编号/名称检索"
                                        disabled={this.isConcrete || this.config.edit}
                                        value={data.invSiteName}
                                        params={{ limit: 20 }}
                                        url={API_URL.site.list}
                                        config={{ id: 'investigationSiteId', name: 'investigationSiteName', code: 'investigationSiteCode', type: 'site', show: 'site' }}
                                        onChange={value => this.handleChange(value, 'invSite')}
                                    />
                                </div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left">中心科室名称:</div>
                                <div className="item-right">{data.departmentName}</div>
                            </li>
                            <li className="modal-item" style={{ lineHeight: '28px' }}>
                                <div className="item-left">{this.config.add && asterisk}参与临床试验人员:</div>
                                <div className="item-right">
                                    <SearchRetrieve
                                        keyword='keywords'
                                        style={{ width: 200 }}
                                        placeholder="输入姓名检索"
                                        disabled={this.config.edit || !data.invSiteId}
                                        value={data.userName}
                                        params={{ limit: 20, hospitalId: data.hospitalId, doctorPostId: data.doctorPostId }}
                                        url={API_URL.hospital.queryDoctorListByDepId}
                                        config={{ id: 'userId', name: 'userCompellation' }}
                                        onChange={value => this.handleChange(value, 'user')}
                                    />
                                </div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left">所在医院:</div>
                                <div className="item-right">{data.hospitalName}</div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left">所在科室:</div>
                                <div className="item-right">{this.user.departmentLocalName}</div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left">{asterisk}临床项目身份:</div>
                                <div className="item-right">
                                    <RadioGroup
                                        value={data.piIdentity}
                                        onChange={e => this.handleChange(e.target.value, 'piIdentity')}
                                    >
                                        {NewPiIdentityRadio}
                                    </RadioGroup>
                                </div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left">性别:</div>
                                <div className="item-right">{Gender[this.user.gender]}</div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left">出生日期:</div>
                                <div className="item-right">{format('date', this.user.birthDate)}</div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left">专业技术职称:</div>
                                <div className="item-right">{this.user.professionalTitle}</div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left">职务:</div>
                                <div className="item-right">{this.user.doctorPosition}</div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left">手机号码:</div>
                                <div className="item-right">{this.user.userMobile}</div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left">固定电话:</div>
                                <div className="item-right">{this.user.userTelphone}</div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left">邮箱:</div>
                                <div className="item-right">{this.user.userEmail}</div>
                            </li>
                        </ul>
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default Update;


// WEBPACK FOOTER //
// ./src/components/site/piInfo/components/Update.js